import { useEffect, useState } from "react";

import ContainerScreen from "@/main/components/shared/containerScreen/containerLayout";
import RowMappingParts from "./rowMappingParts/rowMappingParts";
import KOGPaginationGrid from "@/main/components/shared/paginationGrid/paginationGrid";

import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import { PaginationEnum } from "@/main/services/enum/PaginationEnum";
import { QuoteItemMappingPartViewReponse } from "@/main/models/response";
import { quoteItemApi } from "@/main/api";

import * as S from "./styles";

function MappingPartsScreen() {
	const [idRowToOpenCollapse, setIdRowToOpenCollapse] = useState<string>("");
	const [dataGrid, setDataGrid] = useState<QuoteItemMappingPartViewReponse[]>([]);
	const [formFilters, setFormFilters] = useState<any | null>(null);
	const [totalRecords, setTotalRecords] = useState<number>(0);
	// #region Core Functions
	function onResetSearch() {
		if (isNullUndefined(formFilters)) return;

		setDataGrid([]);
		setFormFilters(null);
	}
	async function getDataMappingParts(filters: any = {}, isResetSearch: boolean = true) {
		const request: any = {
			...(isResetSearch ? {} : formFilters),
			...(filters as any),
			pageIndex: PaginationEnum.PageIndexIntial,
			pageSize: PaginationEnum.PageSize30,
		};

		onResetSearch();
		setFormFilters(request);
	}
	async function fetchDataIntegrationQueue(request: any) {
		return quoteItemApi.getMappingParts(request).then((response) => response.data);
	}
	//#endregion

	// #region Custom Function
	function updateIdRowToOpenCollapse(row: QuoteItemMappingPartViewReponse, isNextPart: boolean = false) {
		const findIndexRemoved = removeItemGrid(row);
		if (findIndexRemoved !== -1) {
			const nextRow = dataGrid[findIndexRemoved + 1];
			if (isNextPart && nextRow) {
				setIdRowToOpenCollapse(nextRow.guidQuoteItem);
			} else {
				setIdRowToOpenCollapse("");
			}
		}
	}

	function removeItemGrid(row: QuoteItemMappingPartViewReponse) {
		const findIndex = dataGrid.findIndex((item) => item.partDescription == row.partDescription);
		if (findIndex === -1) return findIndex;

		// Update grid
		setDataGrid((prev) => prev.filter((item) => item.partDescription !== row.partDescription));
		setTotalRecords(totalRecords - 1);
		return findIndex;
	}

	//#endregion

	useEffect(() => {
		getDataMappingParts();
	}, []);

	const titlePage = `${getTranslateByKey("module.integration")} > ${getTranslateByKey("screen.mappingParts")}`;

	return (
		<ContainerScreen title={titlePage}>
			<KOGPaginationGrid
				showTitleResults
				totalRecords={totalRecords}
				setTotalRecords={setTotalRecords}
				dataGrid={dataGrid}
				formFilters={formFilters}
				setDataGrid={setDataGrid}
				fetchMore={fetchDataIntegrationQueue}
			>
				<S.Container>
					{dataGrid.map((item) => (
						<RowMappingParts
							key={item.guidQuoteItem}
							idRowToOpenCollapse={idRowToOpenCollapse}
							updateIdRowToOpenCollapse={updateIdRowToOpenCollapse}
							mappingParts={item}
							hasLastItem={dataGrid[dataGrid.length - 1].guidQuoteItem === item.guidQuoteItem}
							removeItemGrid={removeItemGrid}
						/>
					))}
				</S.Container>
			</KOGPaginationGrid>
		</ContainerScreen>
	);
}

export default MappingPartsScreen;
